import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ProductContext } from "../../Contexts/ProductContext";
import { AuthContext } from "../../Contexts/AuthContext";
import {
  addRemoveProductToCart,
  getSingleProductStockInformation,
  handleProductQunatityInCart,
} from "../../Utils/cartUtils";
import {
  addRemoveProductToWishlist,
  isProductInWishlist,
} from "../../Utils/wishlistUtils";
import "./CartCardStyle.css";
import NO_IMAGE from '../../Assets/no_img.jpg';
import { CartOperation, IMAGE_URL } from "../../Utils/constant";
import { isEmpty, printDebugLog } from "../../Utils/utils";
import { motion } from "framer-motion";

const CartCard = ({ product }) => {
  const { productState, productDispatch, orderState, orderDispatch, setIsLoading } = useContext(ProductContext);
  const { authState } = useContext(AuthContext);
  const { name, firstImage, quantity, subTotalPrice, finalPrice } = product;
  const isOutOfStock = product?.isOutOfStock ?? false;

  useEffect(() => {
    printDebugLog("CartCard(product)", product);
  }, [product]);

  const navigate = useNavigate();
  const isLogged = authState?.mobile?.length > 0;
  const encodedToken = authState?.mobile;

  const [isRmvFromCartBtnDisabled, setRmvFromCartBtnDisabled] = useState(false);
  const [isAddToWishlistBtnDisabled, setAddToWishlistBtnDisabled] =
    useState(false);
  const [isIncreaseQtyBtnDisabled, setIncreaseQtyBtnDisabled] = useState(false);
  const [isDecreaseQtyBtnDisabled, setDecreaseQtyBtnDisabled] = useState(false);

  const addToWishlistHandler = (product) => {
    if (isLogged) {
      if (isProductInWishlist(productState?.wishlist, product?.prdId)) {
        navigate("/wishlist");
      } else {
        addRemoveProductToWishlist(
          product,
          productDispatch,
          encodedToken,
          true,
          setAddToWishlistBtnDisabled
        );
      }
    } else {
      navigate("/login");
    }
  };


  const getStockDetails = async (product) => {
    printDebugLog("getStockDetails [INIT]", product);
    const inventory = await getSingleProductStockInformation(setIsLoading, product.prdId);
    printDebugLog("getStockDetails [RESPONSE]", inventory);
    if (inventory !== null) {
      navigate("/view/products", { state: { inventory: inventory } })
    }
  }

  return (
    <>
      <motion.div animate={{ y: [0, -8, 0] }}
        whileHover={{ rotate: -1, scale: 1.02 }}
        transition={{
          y: { duration: 1.8, repeat: Infinity, ease: "easeInOut" },
          rotate: { type: "spring", stiffness: 300, damping: 20 },
          scale: { type: "spring", stiffness: 300, damping: 20 }
        }} className="cart-card">
        <div
          className="card-product-img"
          onPointerDown={() => getStockDetails(product)}
        >
          {
            isEmpty(firstImage) ? (
              <img src={NO_IMAGE} alt="no_image" />
            ) : <img src={`${IMAGE_URL}${firstImage}`} alt={name} />
          }
        </div>
        <div className="cart-product-body">
          <div className="cart-product-heading-row">
            <p className="cart-product-name">{name}</p>
            {isOutOfStock && <span className="cart-sold-out-tag">Sold Out</span>}
          </div>
          <p className="cart-product-price">{
            subTotalPrice !== finalPrice ? (
              <>
                <span style={{ textDecoration: "line-through", color: "var(--color-red)", marginRight: "8px" }}>
                  ₹{subTotalPrice}
                </span>
                <span style={{ color: "var(--dark-background-color)", fontWeight: 500 }}>
                  ₹{finalPrice?.toFixed(2) ?? 0.0}
                </span>
              </>
            )
              : <span style={{ color: "var(--dark-background-color)", fontWeight: 500 }}>
                ₹{finalPrice?.toFixed(2) ?? 0.0}
              </span>
          }</p>
          {!isOutOfStock && (
            <div className="cart-product-qunatity">
              <button
                className={
                  isDecreaseQtyBtnDisabled || quantity <= 1 ? "cart-qty-diabled" : ""
                }
                onClick={() =>
                  handleProductQunatityInCart(
                    product,
                    false, productDispatch, orderState, orderDispatch, productState?.cart,
                    setDecreaseQtyBtnDisabled
                  )
                }
                disabled={isDecreaseQtyBtnDisabled || quantity <= 1}
              >
                -
              </button>
              <p>{quantity}</p>
              <button
                className={isIncreaseQtyBtnDisabled ? "cart-qty-diabled" : ""}
                onClick={() =>
                  handleProductQunatityInCart(
                    product,
                    true, productDispatch, orderState, orderDispatch, productState?.cart,
                    setIncreaseQtyBtnDisabled
                  )
                }
                disabled={isIncreaseQtyBtnDisabled}
              >
                +
              </button>
            </div>
          )}
          <div className="cart-product-btn-container">
            <button
              className={
                isRmvFromCartBtnDisabled ? "cart-product-btn-disbaled" : ""
              }
              onClick={() =>
                addRemoveProductToCart(
                  product,
                  productDispatch,
                  encodedToken,
                  CartOperation.permanent_remove,
                  setRmvFromCartBtnDisabled,
                  productState?.cart
                  , orderState, orderDispatch
                )
              }
              disabled={isRmvFromCartBtnDisabled}
            >
              Remove From cart
            </button>
            {/* <button
              className={
                isAddToWishlistBtnDisabled ? "cart-product-btn-disbaled" : ""
              }
              onClick={() => addToWishlistHandler(product)}
              disabled={isAddToWishlistBtnDisabled}
            >
              {isProductInWishlist(productState?.wishlist, product?.prdId) ? (
                <p>Go To Wishlist</p>
              ) : (
                <p>Add To Wishlist</p>
              )}
            </button> */}
          </div>
        </div>
      </motion.div>
    </>
  );
};
export { CartCard };
